import { motion } from 'framer-motion';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Segmented control with a framer sliding indicator (same pattern as the drops tabs). A redesign
// alternative to the filter `Select` for list pages with a small, fixed set of filters. Each tab can
// show a leading icon and a trailing count badge.
export const FilterTabs = ({ options, value, onChange, layoutId }) => (<div className="inline-flex w-fit items-center gap-0.5 rounded-lg bg-white/[0.04] p-1">
		{options.map((option) => {
        const active = option.value === value;
        return (<button key={option.value} type="button" onClick={() => onChange(option.value)} className={cn('relative whitespace-nowrap rounded-lg px-3 py-1.5 text-sm font-medium transition-colors', active ? 'text-white' : 'text-muted-foreground hover:text-foreground')}>
					{active && (<motion.span layoutId={layoutId} className="absolute inset-0 rounded-lg bg-primary" transition={{ type: 'spring', bounce: 0.2, duration: 0.4 }}/>)}
					<span className="relative z-10 flex items-center gap-1.5">
						{option.icon}
						{option.label}
						{typeof option.count === 'number' && (<span className={cn('rounded-full px-1.5 py-0.5 text-[10px] font-semibold leading-none tabular-nums', active ? 'bg-white/20 text-white' : 'bg-white/[0.08] text-muted-foreground')}>
								{option.count}
							</span>)}
					</span>
				</button>);
    })}
	</div>);
